import React from 'react';
type SparkleProps = {
  className?: string;
  color?: string;
};

/** L'étincelle : élément graphique central de la charte. */
export function Sparkle({
  className = '',
  color = '#F2B134'
}: SparkleProps) {
  return <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true" focusable="false" data-id="element-180" data-mp="1hfjjq772dklu">
      <path d="M50 0c2.6 24.3 6.2 30.5 22 34.4C56.8 38.6 52.9 44.4 50 66c-2.9-21.6-6.8-27.4-22-31.6C43.8 30.5 47.4 24.3 50 0Z" transform="translate(0 16)" fill={color} data-id="element-181" data-mp="1cjkz8uouwmqp" />
      <path d="M50 8c1.9 30.2 8.2 38.6 42 42-33.8 3.4-40.1 11.8-42 42-1.9-30.2-8.2-38.6-42-42 33.8-3.4 40.1-11.8 42-42Z" fill={color} data-id="element-182" data-mp="juxc0tkjrnai" />
    </svg>;
}